import React from 'react';

import { NFCustomInfoCarouselCardProps } from '../utils/interface';
import { NFCustomInfoCarouselCardContainer } from './styles';
import { BETTER_FX_ICON, CARET_RIGHT_BLUE_ICON, RIGHT_TRIANGLE_ICON } from '@Images';

const NFCustomInfoCarouselCard = ({
  icon = BETTER_FX_ICON,
  heading,
  subHeading,
  handleOnClick,
  borderColor,
  borderRadius,
  showSeparator = false,
  showCta = false,
  ctaText = 'Know more',
  padding = '0',
  ctaOnclick
}: NFCustomInfoCarouselCardProps): React.ReactElement => {
  return (
    <NFCustomInfoCarouselCardContainer
      borderColor={borderColor}
      borderRadius={borderRadius}
      onClick={handleOnClick}
      showSeparator={showSeparator}
      showCta={showCta}
      padding={padding}
    >
      <img height={48} width={48} src={icon} alt="nium forex cross selling" />
      <div className="text-container">
        <span className="__title">{heading}</span>
        <span className="__description">{subHeading}</span>
      </div>
      {showCta ? (
        <div className="cta-container">
          <span onClick={ctaOnclick} className="cta">
            {ctaText}
          </span>
          <img width={6.75} height={13.5} src={CARET_RIGHT_BLUE_ICON} alt="caret right" />
        </div>
      ) : (
        <img width={16} height={16} src={RIGHT_TRIANGLE_ICON} alt="caret right" />
      )}
    </NFCustomInfoCarouselCardContainer>
  );
};

export default NFCustomInfoCarouselCard;
